import request from "api/axiosClient";

export const getDataEnergyActivationReport = async (values) => {
    const result = await request({
        url: "energy-activation-report/data-statistics",
        method: "POST",
        data: values
    });
    return result?.data;
}

export const getEnergyActivationReportGraphical = async (values) => {
    const result = await request({
        url: "energy-activation-report/graphical-statistics",
        method: "POST",
        data: values
    });
    return result?.data;
}
